module.exports = __webpack_public_path__ + "img/404.1c06499f.jpg";